/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MarketState } from 'store/modules/market_store/types';
import colors from 'styles/colors';
import { getBiddings } from 'store/modules/market_store/actions';
import Loader from 'components/atoms/loader';
import { Link } from 'react-router-dom';
import { linkDaLicitacao } from 'services/market_links';

interface BuyersModalProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  orgao: number;
  params: any;
}

const BuyersModal = (props: BuyersModalProps) => {
  const dispatch = useDispatch();
  const { showModal, setShowModal, orgao, params } = props;
  const { buyer, request } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );

  useEffect(() => {
    orgao > 0 && dispatch(getBiddings(orgao, params));
  }, [orgao]);

  return (
    <Modal size="lg" show={showModal}>
      <div className="row">
        <div className="col-md-12">
          <div className="modal-content">
            <div className="modal-header" style={{ backgroundColor: colors.$dark_light }}>
              <h5 className="modal-title text-white font-weight-bold">Órgão Público</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="px-3">
              <div className="row mt-4">
                <div className="col-md-8">
                  <span className="font-weight-bold">Nome</span>
                  <p>{buyer?.nome}</p>
                </div>
                <div className="col-md-4">
                  <span className="font-weight-bold">UASG </span>
                  <p>{buyer?.uasg}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-7">
                  <span className="font-weight-bold">Endereço</span>
                  <p>{buyer?.endereco}</p>
                </div>
                <div className="col-md-3">
                  <span className="font-weight-bold">Cidade </span>
                  <p>{buyer?.cidade}</p>
                </div>
                <div className="col-md-2">
                  <span className="font-weight-bold">Estado</span>
                  <p>{buyer?.estado}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <span className="font-weight-bold">Site</span>
                  <p>{buyer?.edital_site}</p>
                </div>
              </div>
              <hr />
              {request?.get_bidding?.loading ? (
                <Loader />
              ) : (
                <>
                  <div className="col-md-12 mb-3">
                    <b>
                      Total de{' '}
                      {buyer?.licitacoes?.length === 1
                        ? `${buyer?.licitacoes?.length} resultado de licitação relacionada`
                        : `${buyer?.licitacoes?.length.toLocaleString('pt-br', {
                            style: 'decimal',
                            currency: 'BRL',
                          })} resultados de licitações relacionadas`}
                    </b>
                  </div>
                  <div className="card shadow mt-3">
                    <div className="table-responsive" style={{ maxHeight: '330px' }}>
                      <table className="table table-hover w-auto mb-0">
                        <thead style={{ backgroundColor: '#EBECEF' }}>
                          <tr>
                            <th scope="col">Objeto</th>
                            <th scope="col">Edital</th>
                            <th scope="col" />
                          </tr>
                        </thead>
                        <tbody>
                          {buyer?.licitacoes?.map((licitacao) => (
                            <tr key={licitacao.licitacao.id}>
                              <td>{licitacao?.licitacao?.objeto}</td>
                              <td>{licitacao?.licitacao?.edital}</td>
                              <td>
                                <Link
                                  className="btn btn-sm btn-primary"
                                  target="_blank"
                                  rel="noreferrer"
                                  to={linkDaLicitacao(licitacao.licitacao.id)}
                                >
                                  Acessar
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => setShowModal(false)}
              >
                fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BuyersModal;
